// add more polyfills if needed
import 'dom4';
import 'core-js/features/array/find';
import 'core-js/features/array/find-index';
import 'core-js/features/set';
import 'core-js/features/map';

import './events/scroll';
import './modules/breakpoints';

import './modules/activable';
import './modules/layout';
import './modules/anchor';
import './modules/header';
import './modules/search';
import './modules/nearby';
import './modules/datalist';
import './global';
import './modules/product-wizard';
import './modules/product-wizard-button';
import './modules/form';
import './modules/flap';
// import './modules/home-scroll';
import './modules/mosaic';
import './modules/cloner';
import './modules/products';
import './modules/slider';
import './modules/ranger';
import './modules/catalog';
import './modules/project';
import './modules/region-suggestion-banner';
import './modules/projcal';
import './modules/personalisationform';
import './modules/pdfviewer';
import './modules/smartlighting-features';
import './modules/survey';
import './modules/popup';
import './modules/mounting';
import './modules/color-changer';
import './modules/objectfitcovervideos';
